import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";

import { RoutePathInfo } from "./interface";

export const TabRouterPath = DeprecatedGlobalAppV1Paths;

/**
 * @deprecated
 * This is no longer being maintained.
 * This is only used for logging and for one deprecated hook.
 * We will no longer be maintaining names for routes
 * The routes are the definitive truth, and it is more useful to know the exact route in logs.
 */
export const TabRouterPathInfo: Record<keyof typeof TabRouterPath, RoutePathInfo> = {
  MY_SHIFTS: {
    name: "My Shifts",
  },
  OPEN_SHIFTS: {
    name: "Open Shift Calendar",
  },
  RATINGS: {
    name: "Attendance Rating",
  },
  RATINGS_BADGES: {
    name: "Your Badges",
  },
  ACCOUNT: {
    name: "Account Page",
  },
  CHAT: {
    name: "Chat Page",
  },
  SUPPORT: {
    name: "Support Page",
  },
  ADDRESS: {
    name: "Address View",
  },
  ADDRESS_SEARCH: {
    name: "Address Search View",
  },
  ADDRESS_EDIT: {
    name: "Address Edit Page",
  },
  PAYROLL: {
    name: "Payroll View",
  },
  PROFILE: {
    name: "Profile View",
  },
  PROFILE_CONTRACT: {
    name: "Contract View",
  },
  SAVINGS: {
    name: "Savings",
  },
  SAVINGS_CONFIGURATION_GOALS: {
    name: "Savings Configuration Goals",
  },
  SAVINGS_CONFIGURATION_ALLOCATION: {
    name: "Savings Configuration Allocation",
  },
  SAVINGS_BOOK_CALL: {
    name: "Savings Book Call",
  },
  MY_SHIFT_DETAIL: {
    name: "Shift Detail Page",
  },
  UNVERIFIED_SHIFTS: {
    name: "Unverified Shifts Page",
  },
  SUCCESS_ONBOARDING: {
    name: "Success Onboarded",
  },
  PAYMENT_SERVICE_ONBOARDING: {
    name: "Onboarding Payment Service",
  },
  UPDATED_CONTRACTOR_AGREEMENT: {
    name: "Updated Contractor Agreement",
  },
  FACILITY_DETAIL: {
    name: "Workplace Detail",
  },
  NEED_HELP: {
    name: "Need Help?",
  },
  HELP_DETAILS: {
    name: "Help Details",
  },
  UPDATE_PROFILE: {
    name: "Update Profile",
  },
  DELETE_DATA: {
    name: "Delete Data",
  },
  LICENSE_MANAGER: {
    name: "License Manager",
  },
  LICENSE_MANAGER_ADD: {
    name: "Add License",
  },
  LICENSE_DETAILS: {
    name: "License Details Page",
  },
  ADD_LICENSE: {
    name: "Add License",
  },
  LICENSE_RECIPROCITY: {
    name: "License Reciprocity",
  },
  COLLEAGUE_LIST: {
    name: "Colleague List",
  },
  FRIENDS_LIST: {
    name: "Work with Friends",
  },
  SETUP_STRIPE: {
    name: "Setup Stripe",
  },
  PROFESSIONAL_REFERENCE: {
    name: "Professional References",
  },
  NOTIFICATION_CENTER: {
    name: "Notification Center",
  },
  RATE_NEGOTIATIONS: {
    name: "Rate Negotiations",
  },
  RATINGS_A_TEAM: {
    name: "A-Team",
  },
  CAREER_AGENT: {
    name: "Career Agent",
  },
  WORKPLACE_REFERRALS: {
    name: "Workplace Referrals",
  },
  RATE_NEGOTIATION_TOOL: {
    name: "Rate Negotiation Tool",
  },
  SHIFT_FEEDBACK_RESOLVER: {
    name: "Shift Feedback Resolver",
  },
  NOTIFICATION_PREFERENCE: {
    name: "Notification Preferences",
  },
};

/**
 * Checks to see if the base path is a shift path.
 * @param pathname Current path
 * @returns true if the path is a shift path
 */
export function isAShiftPath(pathname: string) {
  return (
    pathname.startsWith(TabRouterPath.OPEN_SHIFTS) || pathname.startsWith(TabRouterPath.MY_SHIFTS)
  );
}
